import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormControl} from '@angular/forms';
import {Observable, Subscription} from 'rxjs';
import {UsersAnagrafService} from '../../../general-services/service-users-anagraf/users-anagraf.service';
import {map, startWith} from 'rxjs/operators';
import {UserModel} from '../../../../models/UserModel';

@Component({
  selector: 'app-user-surname-filter',
  templateUrl: './user-surname-filter.component.html',
  styleUrls: ['./user-surname-filter.component.scss']
})
export class UserSurnameFilterComponent extends ProjectConstants implements OnInit, OnDestroy {

  listFilterSurnames: any[];

  surnamesFormControl = new FormControl();
  surnamesFilteredOptions: Observable<any[]>;

  getAllUsers: Subscription;

  @Output() dataFiltered = new EventEmitter<any>();

  constructor(private usersService: UsersAnagrafService) {
    super();
    this.getAll();
  }

  ngOnInit() {
  }

  filterTable(): void {
    const filter: UserModel = new UserModel();

    filter.surname = this.surnamesFormControl.value;

    this.dataFiltered.emit(filter);
  }


  getAll() {
    this.getAllUsers = this.usersService.getAll(this.usersService.baseUrl, null)
      .subscribe(
        (result: any) => {
          this.listFilterSurnames = result.filter(
            (thing, i, arr) => arr.findIndex(t => t.surname.toUpperCase() === thing.surname.toUpperCase()) === i
          );
          this.listFilterSurnames.sort((a, b) => a.surname.localeCompare(b.surname));
          this.surnamesFormControl.setValue(null);
          this.applyUserFormControlFilteredOptions();
        }
      );
  }

  // AUTOCOMPLETE Units

  applyUserFormControlFilteredOptions() {
    this.surnamesFilteredOptions = this.surnamesFormControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterUsersOptionList(value))
      );
  }

  displaySurnamesAutocompleteFn(element: any) {
    if (element) {
      return element.surname;
    }
  }

  ngOnDestroy(): void {
  }

  private _filterUsersOptionList(value: string): string[] {
    if (value === '') {
      this.surnamesFormControl.setValue(null);
    }

    if (value == null) {
      value = '';
    } else if (typeof value !== 'string') {
      return null;
    }

    return this.listFilterSurnames.filter(option => {
      if (option.surname.toLowerCase().includes(value.toLowerCase())) {
        return option;
      }
    });
  }

}
